import Swiper from "swiper/bundle";

/**
 * Инициализация слайдеров для секции "Что мы производим"
 * Создает независимые слайдеры с навигацией
 */
export const initWorkSliders = () => {
  const sliderSelectors = [".slider-1", ".slider-2", ".slider-3"];
  const sliderElements = sliderSelectors
    .map((selector) => document.querySelector(selector))
    .filter(Boolean);

  if (sliderElements.length === 0) {
    return;
  }

  const sliderConfig = {
    slidesPerView: "auto",
    spaceBetween: 24,
    loop: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  };

  /**
   * Обновляет состояние кнопок навигации
   * @param {Swiper} swiper - Экземпляр Swiper
   * @param {HTMLElement} prevBtn - Кнопка "Назад"
   * @param {HTMLElement} nextBtn - Кнопка "Вперед"
   */
  const updateButtons = (swiper, prevBtn, nextBtn) => {
    if (!prevBtn || !nextBtn || !swiper) return;

    prevBtn.disabled = swiper.isBeginning;
    nextBtn.disabled = swiper.isEnd;
  };

  /**
   * Инициализирует один слайдер
   * @param {HTMLElement} sliderEl - Элемент слайдера
   * @returns {Swiper|null} Экземпляр Swiper или null
   */
  const initSlider = (sliderEl) => {
    const section = sliderEl.closest(".slider-section");
    if (!section) return null;

    const prevBtn = section.querySelector(".slider-section__btn--prev");
    const nextBtn = section.querySelector(".slider-section__btn--next");

    if (!prevBtn || !nextBtn) return null;

    const swiper = new Swiper(sliderEl, {
      ...sliderConfig,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: (swiperInstance) => {
          updateButtons(swiperInstance, prevBtn, nextBtn);
        },
        slideChange: (swiperInstance) => {
          updateButtons(swiperInstance, prevBtn, nextBtn);
        },
      },
    });

    return swiper;
  };

  // Инициализируем все слайдеры
  sliderElements.forEach((sliderEl) => {
    try {
      initSlider(sliderEl);
    } catch (error) {
      console.error("Ошибка инициализации слайдера:", error);
    }
  });
};
